import {lazy} from 'react'

const CHUNK_LOAD_ERROR = /ChunkLoadError|Loading (CSS )?chunk .* failed|Failed to fetch dynamically imported module/i
const RETRY_COOLDOWN_MS = 10000

const getRetryStorageKey = (retryKey) => `doan-lazy-retry:${retryKey}`

const clearRetry = (storageKey) => {
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.removeItem(storageKey)
  } catch (e) {
    // Browsers can disable session storage. A successful import needs no fallback.
  }
}

const reloadOnce = (storageKey) => {
  if (typeof window === 'undefined') return false

  try {
    const lastRetry = Number(window.sessionStorage.getItem(storageKey) || 0)
    if (lastRetry && Date.now() - lastRetry < RETRY_COOLDOWN_MS) return false

    window.sessionStorage.setItem(storageKey, String(Date.now()))
    window.location.reload()
    return true
  } catch (e) {
    return false
  }
}

const lazyWithRetry = (importer, retryKey) => {
  const storageKey = getRetryStorageKey(retryKey)

  return lazy(() => importer()
    .then((module) => {
      clearRetry(storageKey)
      return module
    })
    .catch((error) => {
      const message = `${error && error.name ? error.name : ''} ${error && error.message ? error.message : ''}`

      if (CHUNK_LOAD_ERROR.test(message) && reloadOnce(storageKey)) {
        return new Promise(() => {})
      }

      throw error
    }))
}

export default lazyWithRetry
